import React, { useEffect, useRef, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Switch,
  DarkMode,
  Select,
  Checkbox,
  background,
  useToast,
} from "@chakra-ui/react";

// Images

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";

// Data
import { billingData } from "variables/general";
import { useLoader } from "components/Loader/loader";
import useApiReq from "variables/apireq";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";

function PaymentPay() {
  const titleColor = "white";
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [advertiserList, setAdvertiserList] = useState([]);
  const toast = useToast({ position: "top" });
  const history = useHistory();

  const { setIsLoading, isLoading } = useLoader();
  const fetchOrders = async (data) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "order/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response);
        console.log(res.response.reverse());
        setOptions(
          res.response.reverse().map((item) => ({
            label: ` ${new Date(item.created_at).toLocaleDateString()} - ${
              item.price
            } - Analytics: ${item.analytics ? "Yes" : "No"} - Facebook: ${
              item.facebook ? "Yes" : "No"
            }`,

            value: item.uuid,
          }))
        );
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const [formData, setFormData] = useState({
    order: "",
  });
  const fetchAdvertiser = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "advertiser/list/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setAdvertiserList(res.response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAdvertiser();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("group") === "Publisher") {
      setFormData((prev) => ({
        ...prev,
        advertiser: "",
      }));
    }
  }, []);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "advertiser") {
      fetchOrders({
        advertiser_uuid: value,
        payment: "True",
      });
    }
  };
  useEffect(() => {
    if (selected) {
      const collected = data.find((item) => item.uuid === selected.value);
      setFormData((prev) => ({
        ...prev,
        order:
          new Date(collected.created_at).toLocaleDateString() +
          " - " +
          collected?.total +
          " - " +
          collected?.package_type,
      }));
    }
  }, [selected]);
  const createPayment = async (data) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: "payment/add/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setError(null);
        toast({
          title: "Success",
          description: "Payment successful",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setFormData({
          advertiser: "",
          ammount: "",
          order_uuid: "",
        });

        setSelected(null);
        if (localStorage.getItem("group") === "Publisher") {
          setFormData((prev) => ({
            ...prev,
            advertiser: "",
          }));
        }
        history.push(
          `/${localStorage.getItem("group").toLowerCase()}/payment/list`
        );
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      formData.order_uuid === "" ||
      formData.amount === "" ||
      formData.advertiser === ""
    ) {
      toast({
        title: "Error",
        description: "Please fill all the fields",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    const data = {
      advertiser_uuid: selected.value,
      amount: formData.amount,
      order_uuid: selected.value,
    };
    console.log(data);

    createPayment(data);
  };

  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
        {/* Form */}
        <Card p="16px">
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                Payment Add
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <GradientBorder
                p="2px"
                ml={{ base: "0px", lg: "24px" }}
                w="100%"
                me={{ base: "none", lg: "30px", xl: "none" }}
                background="transparent"
                boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                borderRadius="30px"
              >
                <Flex
                  background="transparent"
                  borderRadius="30px"
                  direction="column"
                  p="40px"
                  minW={{ base: "unset", md: "430px", xl: "450px" }}
                  w="100%"
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,.5)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <FormControl>
                      {localStorage.getItem("group") === "Publisher" && (
                        <>
                          <FormLabel
                            color={titleColor}
                            ms="4px"
                            fontSize="sm"
                            fontWeight="normal"
                          >
                            Select Advertiser
                          </FormLabel>
                          <GradientBorder
                            mb="24px"
                            h="50px"
                            w={{ base: "100%", lg: "100%" }}
                            borderRadius="20px"
                          >
                            <Select
                              color={titleColor}
                              bg={{
                                base: "rgb(19,21,54)",
                              }}
                              border="transparent"
                              borderRadius="20px"
                              fontSize="sm"
                              size="lg"
                              w={{ base: "100%", lg: "100%" }}
                              maxW="100%"
                              h="46px"
                              type="text"
                              placeholder="Select Advertiser"
                              name="advertiser"
                              value={formData.advertiser}
                              onChange={handleChange}
                              required
                              sx={{
                                option: {
                                  backgroundColor: "rgb(19,21,54)",
                                  color: "white",
                                },
                              }}
                            >
                              {advertiserList?.map((item) => (
                                <option key={item.uuid} value={item.uuid}>
                                  {item.user.username}
                                </option>
                              ))}
                            </Select>
                          </GradientBorder>
                        </>
                      )}

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Order
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <ChakraStyledSelect
                          placeholder="Select Order"
                          options={options}
                          setSelectedValue={setSelected}
                          selectedValue={selected}
                          disabled={!formData.advertiser}
                          isMulti={false}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Amount
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Amount"
                          name="amount"
                          value={formData.amount}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>
                      <Button
                        variant="brand"
                        fontSize="1.2rem"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </form>
                </Flex>
              </GradientBorder>
            </Flex>
          </CardBody>
        </Card>

        {/* Preview */}
        <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <Flex direction="column">
            <CardHeader py="16px">
              <Text color="#fff" fontSize="lg" fontWeight="bold">
                Preview
              </Text>
            </CardHeader>
            <CardBody>
              <Flex direction="column" w="100%">
                {Object.entries(formData).map(([key, value]) =>
                  key === "package" ? (
                    data.find((item) => item.uuid === selected) ? (
                      Object.entries(
                        data.find((item) => item.uuid === selected)
                      )
                        .filter(([key2]) =>
                          ["name", "prnumber", "type", "price"].includes(key2)
                        )
                        .map(([key2, value2]) => (
                          <Text
                            key={key2}
                            color="#fff"
                            fontSize="lg"
                            fontWeight="500"
                            style={{
                              textTransform: "capitalize",
                              marginBottom: "10px",
                            }}
                          >
                            {key2.replace(/([A-Z])/g, " $1")}: {value2}
                          </Text>
                        ))
                    ) : null
                  ) : value ? (
                    <Text
                      key={key}
                      color="#fff"
                      fontSize="lg"
                      fontWeight="500"
                      style={{
                        textTransform: "capitalize",
                        marginBottom: "10px",
                      }}
                    >
                      {key.replace(/([A-Z])/g, " $1")}:{" "}
                      {typeof value === "boolean"
                        ? value
                          ? "Yes"
                          : "No"
                        : key === "advertiser"
                        ? advertiserList.find((item) => item.uuid === value)
                            .user.username
                        : value}
                    </Text>
                  ) : null
                )}
              </Flex>
            </CardBody>
          </Flex>
        </Card>
      </Grid>
    </Flex>
  );
}

export default PaymentPay;
